import React from "react";
import "./Ads.css";

function Ads (){
    return <div className="ads">Ads</div>;
}

export default Ads;